// extracted by mini-css-extract-plugin
export default {"peopleInput":"mIVvmbpqWt57_lcotis4J"};